export default function ErrorPage() {
  return (
    <div className="grid h-screen w-full place-items-center">
      <div className="flex flex-col content-center items-center ">
        <h1 className="mb-6 text-3xl">There has been an error...</h1>
        <div className="h-fit w-32">
          <img src="https://i.ibb.co/64nhCML/pngegg.png" />
        </div>
      </div>
    </div>
  )
}
